export const backgroundGradientOptions = ['Blue10Top', 'BlueTop', 'White20', 'WhiteTop', 'None'];

export const backgroundColorOptions = ['Blue10', 'TrueWhite', 'White', 'WhiteOff', 'None'];
export const reviewsBackgroundColorOptions = [...backgroundColorOptions, 'Grey', 'GreyLt'];

export const iconColorOptions = ['White', 'Blue', 'Navy'];

export const altBackgroundColorOptions = ['Turquoise20', 'Blue10', 'None'];

export const waveColorOptions = ['Turquoise20', 'White', 'Blue10'];

export const textColorOptionsLimited = ['BlueSecondary', 'Blue', 'Navy', 'Turquoise'];

export const textColorOptionsExtended = [
    ...backgroundColorOptions,
    'Black',
    'Blue',
    'BlueSecondary',
    'Grey',
    'GreyLt',
    'Navy',
    'Navy50',
    'Navy80',
    'Red',
    'Turquoise',
    'Turquoise20',
    'Turquoise2033',
].filter((color) => color !== 'None'); // Exclude 'None' from the extended options

export const buttonVariantOptions = ['primary', 'secondary', 'cta', 'overlay'];

export const textColorOptionsWithWhite = [...textColorOptionsLimited, 'White'];

export const GradientsColorsMap = {
    WhiteTop: 'linear-gradient(360deg, var(--milan-off-white) 38%, var(--milan-white) 100%)',
    White20: 'linear-gradient(360deg, var(--milan-blue-10) 45.41%, var(--milan-white) 100%)',
    BlueTop: 'linear-gradient(180deg, var(--milan-off-white) 38%, var(--milan-white) 100%)',
    Blue10Top: 'linear-gradient(180deg, var(--milan-blue-10) 45.41%, var(--milan-white) 100%)',
    default: '',
} as const;
